<template>
    <div class="py-4 container-fluid">
      <div class="row">
      <!-- top buttons -->
      <div class="col-12">
            <div class="card mb-4">
                <span class="top-actions"> 
                    <!--  -->
                    <button type="button" class="mycustom-success-button" data-bs-toggle="modal"  data-backdrop="static" data-keyboard="false" data-bs-target="#createaddclassModal">
                        <i class="bi bi-plus-square-dotted"></i> Add Item
                    </button>
                    <!--  -->
                    
                </span>
                
            </div>
        </div>
        <!-- end top buttons -->  
        <div class="col-12">
         <!-- table start -->
         <div class="card mb-4">
    
          <div class="card-body px-0 pt-0 pb-2">
            <div class="table-responsive p-0">
              <nav>
                <!-- <Search :PlaceHolder="placeHolderText" @search="handleSearch" /> -->
                <Search :placeholder=placeHolderText @onsearch="handleSearch" />
              </nav>
              <table class="table align-items-center mb-0">
                <thead>
                  <tr>
                    <th
                      class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                    >
                      #s/n
                    </th>
                    <th
                      class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                    >
                      Category Name
                    </th>
                   
                    
                    <th class="text-secondary opacity-7"></th>
                  </tr>
                </thead>

                <div  v-if="tableLoading">
                  <div class="loader" v-if="apiLoading">
                    <div class="spinner"></div>
                    <p>Loading...</p>
                  </div>
                </div>


                <tbody v-if="users.length">
                  <tr v-for="user in users" :key="user.id">
                    <td>
                      #{{ user.id  }}
                    </td>
                    <td>
                      <div class="d-flex px-2 py-1">
                        <div>
                        
                        </div>
                        <div class="d-flex flex-column justify-content-center">
                          <h6 class="mb-0 text-sm">{{ user.class_name }}</h6>
                          <p class="text-xs text-secondary mb-0">
                            {{ user.class_name  }}
                          </p>
                        </div>
                      </div>
                    </td>
                  
                    <td class="align-middle">
                      <a
                        href="javascript:;"
                        class="text-secondary font-weight-bold text-xs"
                        data-toggle="tooltip"
                        data-original-title="Edit user"
                        >More</a>
                    </td>
                  </tr>
                
                </tbody>
                <div v-else>
                  <p class="tocenter-container" v-if="!apiLoading">No Records found.</p>
                </div>
              </table>
               <!-- Pagination   @page-change="handlePageChange" :current-page="currentPage" :total-pages="totalPags" -->
                <!-- <pagination :all-data="allData" @content-change="handleContentChange" /> -->
                <div  v-if="apiLoading">Loading...</div>
                <pagination v-if="!apiLoading" :all-data="allData" @content-change="handleContentChange" @loader-set="loaderSet"/>

              <!--  -->
            </div>
          </div>
        </div>
         <!-- table end -->
         
        </div>
      </div>
      
    </div>

    <CreateclassModal />
  </template>
 

<script>
import { generalApiRequest } from "../../api/apiIndex";
import Pagination from '../components/pagination.vue';
import Search from '../components/search.vue';
import CreateclassModal from './modals/CreateclassModal.vue';

//import axios from "axios";

export default {
  name: "itemclasses",
  data() {
    return {
      users: [],
      allData:{},
      apiLoading:true,
      tableLoading:true,
      placeHolderText:"Search class"
    };
  },
  components: {
    Pagination,
    Search,
    CreateclassModal
  },
  
  methods: {
    async handleSearch(searchTerm){
      //console.log("the serch rem is " +searchTerm);
      try {
        this.apiLoading = true;
          const url = 'inventory/searchCompanyItemClass'; 
          const body = { search_param: searchTerm};

          const rs = await generalApiRequest(url, 'GET', body, 1);
         console.log(rs);
          this.allData = rs;
          this.apiLoading = false;
           console.log(this.allData);

      } catch (error) {
         console.error('Error fetching data:', error);
      }
   
    },
    
    handleContentChange(contents) {
      // console.log("procceds");
      // console.log(contents);
      this.users = contents;
    },

    loaderSet(value){
      if (value==true) {
        this.users= [];
      }
      this.tableLoading = value;
      //console.log(value);
      //this.apiLoading = value;
    },

    async callApi() {
      try {
        const url = 'inventory/getCompanyItemClass'; //?page=1
        const body = {};
    
       // const data = await getMethodRequest(url, body, 1);
        const data = await generalApiRequest(url, 'GET', body, 1)
         console.log(data);
        this.allData = data;
        this.apiLoading = false;
      } catch (error) {
         console.error('Error fetching data:', error);
      }
    },
   
   
  },

  mounted() {
    this.callApi();
    
  },
};
</script>


  